<ng-container *transloco="let t; prefix: 'documents.scoring-metrics.metricdata-section'">
  <app-document-scoring-metrics-section
    [panel]="panel()"
    (expandedChanged)="onExpandedChanged($event)"
  >
    <table
      mat-table
      [dataSource]="metricsDs()"
      matSort
      matSortDisableClear
      [matSortDisabled]="!allowSorting()"
    >
      <ng-container matColumnDef="name">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          <span>{{ t('metric') }}</span>
        </th>

        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-sort-header mat-header-cell *matHeaderCellDef>
          <span>{{ t('value') }}</span>
        </th>

        <td mat-cell *matCellDef="let element">
          @switch (element.type) {
            @case ('date') {
              {{ element.value | lexDate: 'long' }}
            }
            @case ('url') {
              <a class="value" href="{{ element.value }}" target="_blank">{{ element.value }}</a>
            }
            @default {
              {{ element.value }}
            }
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>

      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </app-document-scoring-metrics-section>
</ng-container>
